import { color as foundationColor } from '../foundation';
import { color } from '../semantic';

const { info, neutral, primary } = foundationColor;

export const card = {
  color: {
    container: {
      border: {
        default: color.border.default.light,   // default border color for cards
        active: color.border.active.medium,   // border color for active cards
      },
      background: {
        default: color.bg.surface,            // default card background
        active: color.bg.container.active,    // background for active cards
        nested: color.bg.container.muted,     // background for nested surfaces within cards (ex: card within a panel)
      },
    },
    selection: {
      border: {
        off: {
          default: color.border.default.light,  // default border color for unselected cards
          hover: color.border.default.dark,     // border color for unselected cards on hover
        },
        on: {
          default: color.border.active.medium,  // default border color for selected cards
          hover: color.border.active.dark,     // border color for selected cards on hover
        }
      },
      background: {
        off: {
          default: color.bg.surface,           // default background for unselected cards
          disabled: color.bg.container.muted,  // background for unselected cards in disabled state
        },
        on: {
          default: color.bg.container.active,  // default background for selected cards
          disabled: info[50],                  // background for selected cards in disabled state
        },
      },
    },
  },
};

export default card;
